export const scopeNavigationPreviewRoutes = [
  {
    id: "private_repositories_preview",
    path: "/repositories/private",
    section: "Fleet",
    label: "Private Repositories",
    live: true,
  },
  {
    id: "waste_overview_preview",
    path: "/engineering-waste",
    section: "Analytics",
    label: "Engineering Waste Overview",
    live: false,
  },
  {
    id: "waste_impact_outcomes_preview",
    path: "/engineering-waste/impact-outcomes",
    section: "Analytics",
    label: "Impact and Outcomes",
    live: false,
  },
  {
    id: "waste_plan_preview",
    path: "/engineering-waste/90-day-plan",
    section: "Analytics",
    label: "90-Day Plan",
    live: true,
  },
  {
    id: "issue_overview_preview",
    path: "/issue-intelligence",
    section: "Analytics",
    label: "Issue Intelligence Overview",
    live: false,
  },
  {
    id: "automation_overview_preview",
    path: "/automations",
    section: "Analytics",
    label: "Automations Overview",
    live: true,
  },
  {
    id: "automation_activity_ledger",
    path: "/automations/activity-ledger",
    section: "Analytics",
    label: "Activity Ledger",
    live: true,
  },
  {
    id: "estate_map",
    path: "/estates/map",
    section: "Fleet",
    label: "Estate Map",
    live: true,
  },
  {
    id: "automation_tasks_preview",
    path: "/automations/tasks",
    section: "Analytics",
    label: "Tasks",
    live: true,
  },
  {
    id: "automation_maintenance_plan_preview",
    path: "/automations/maintenance-plan",
    section: "Analytics",
    label: "Maintenance Plan",
    live: true,
  },
  {
    id: "automation_campaigns_preview",
    path: "/automations/campaigns",
    section: "Analytics",
    label: "Campaigns",
    live: true,
  },
  {
    id: "automation_dependency_graph_quad_preview",
    path: "/automations/dependency-graph",
    section: "Analytics",
    label: "Dependency Graph",
    live: true,
  },
  {
    id: "automation_the_graph_preview",
    path: "/automations/the-graph",
    section: "Analytics",
    label: "The Graph",
    live: true,
  },
  {
    id: "automation_action_studio_preview",
    path: "/automations/action-studio",
    section: "Analytics",
    label: "Task Studio",
    live: true,
  },
  {
    id: "checks_preview",
    path: "/standards-and-tastes/checks",
    section: "Standards and Tastes",
    label: "Checks",
    live: false,
  },
  {
    id: "repository_canon_preview",
    path: "/standards-and-tastes/repository-canon",
    section: "Standards and Tastes",
    label: "Repository Canon",
    live: false,
  },
  {
    id: "contracts_preview",
    path: "/standards-and-tastes/contracts",
    section: "Standards and Tastes",
    label: "Contracts",
    live: false,
  },
  {
    id: "agents_md_preview",
    path: "/standards-and-tastes/agents-md",
    section: "Standards and Tastes",
    label: "Agents.md",
    live: false,
  },
  {
    id: "estates_overview_preview",
    path: "/estates",
    section: "Fleet",
    label: "Estates Overview",
    live: false,
  },
  {
    id: "services_preview",
    path: "/estates/services",
    section: "Fleet",
    label: "Services",
    live: false,
  },
  {
    id: "tools_overview_preview",
    path: "/tools",
    section: "Settings",
    label: "Tools Overview",
    live: false,
  },
] as const;
